import {
  Box,
  Grid,
  TextField,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import DateAdapter from '@mui/lab/AdapterDateFns';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

const TaxBillColAndPayForm = ({ activeStep, formik }) => {
  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        my: 2,
        px: 2,
      }}
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={4}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            select
            disabled={activeStep !== 2}
            id="procTyp"
            name="procTyp"
            label="지급종류"
            value={formik.values.procTyp}
            onChange={(event) => {
              formik.setFieldValue('procTyp', event.target.value);
            }}
            error={formik.touched.procTyp && Boolean(formik.errors.procTyp)}
            helperText={formik.touched.procTyp && formik.errors.procTyp}
          >
            <MenuItem value="일반">일반</MenuItem>
            <MenuItem value="현금">현금</MenuItem>
            <MenuItem value="기타">기타</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <LocalizationProvider dateAdapter={DateAdapter}>
            <DatePicker
              label="수금(지급)예정일"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              disabled={activeStep !== 2}
              id="procPlanDt"
              name="procPlanDt"
              value={formik.values.procPlanDt || ''}
              onChange={(newValue) => {
                formik.setFieldValue('procPlanDt', newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  error={
                    formik.touched.procPlanDt &&
                    Boolean(formik.errors.procPlanDt)
                  }
                  helperText={
                    formik.touched.procPlanDt && formik.errors.procPlanDt
                  }
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={4}>
          <FormGroup>
            <FormControlLabel
              id="procPlanYn"
              name="procPlanYn"
              label="수금(지급)요청 여부"
              disabled={activeStep !== 2}
              control={
                <Checkbox
                  checked={formik.values.procPlanYn}
                  onChange={formik.handleChange}
                />
              }
            />
          </FormGroup>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={4}>
          <LocalizationProvider dateAdapter={DateAdapter}>
            <DatePicker
              label="수금(지급)일"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              disabled={activeStep !== 3}
              id="procCompDt"
              name="procCompDt"
              value={formik.values.procCompDt || ''}
              onChange={(newValue) => {
                formik.setFieldValue('procCompDt', newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  error={
                    formik.touched.procCompDt &&
                    Boolean(formik.errors.procCompDt)
                  }
                  helperText={
                    formik.touched.procCompDt && formik.errors.procCompDt
                  }
                  fullWidth
                />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={4}>
          <FormGroup>
            <FormControlLabel
              id="procCompYn"
              name="procCompYn"
              disabled={activeStep !== 3}
              label="수금(지급) 완료 여부"
              control={
                <Checkbox
                  checked={formik.values.procCompYn}
                  onChange={formik.handleChange}
                />
              }
            />
          </FormGroup>
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid>
      {(activeStep === 2 || activeStep === 3) && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            my: 2,
          }}
        >
          <Button
            type="submit"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TaxBillColAndPayForm;
